import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../../data/testimonials';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-bone px-4 py-14 sm:px-6 sm:py-20" data-id="element-82" data-mp="122dcx9d3pxct">
      <div className="mx-auto w-full max-w-2xl" data-id="element-83" data-mp="124g9kc8reoqi">
        <SectionHeading eyebrow="❓ Frequently Asked Questions" title="Everything You Need to Know" data-id="element-84" data-mp="1pt8xblf89qa1" />

        <ul className="mt-9 space-y-3" data-id="element-85" data-mp="1uq94y0rq7139">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.question} className="overflow-hidden rounded-2xl border border-slate-200 bg-white" data-id="element-86" data-mp="1g0bne3oax9n1" data-mpi={i}>
                <h3 data-id="element-87" data-mp="28q0oeh10h9on">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left sm:px-5" data-id="element-88" data-mp="28pilx2nr9z8a">
                    <span className="text-[14.5px] font-bold leading-snug text-navy-950" data-id="element-89" data-mp="2jsp6z3f710a9">
                      {faq.question}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold-500 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-90" data-mp="2tplh1dkqpugx" />
                  </button>
                </h3>
                {isOpen && <p className="px-4 pb-4 text-[14px] leading-relaxed text-slate-600 sm:px-5" data-id="element-91" data-mp="3hctlxue9b1if">
                    {faq.answer}
                  </p>}
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-9 max-w-md" data-id="element-92" data-mp="1i1s8293vq1f3">
          <CTAButton label="Get started now — $27 USD" data-id="element-93" data-mp="1i33k0w7hafha" />
        </div>
      </div>
    </section>;
}